/**
 * Navigate to the portal's REAL logout endpoint (GET variant, 2026-07-08): it
 * deletes the portal-redis session and clears the session_token cookie, then
 * redirects home. (A fetch to the POST variant would be blocked by our
 * connect-src 'self' CSP — a top-level navigation is exempt.)
 * Separate module so tests can mock the navigation.
 */
export function portalLogout(): void {
  window.location.href = 'https://nadc1.net/api/auth/logout';
}
